import React, { useCallback } from "react";
import { Entity } from "../../../utils/constants";
import useDataTable from "./useDataTable";

interface Props {
  entity: Entity;
  placeholder: string;
}

const TableSearchInput: React.FC<Props> = ({ entity, placeholder }) => {
  const searchInput = useDataTable(
    useCallback((state) => state.searchInput[entity], [entity])
  );
  const updateSearchInput = useDataTable((state) => state.updateSearchInput);

  const handleSearchFormSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
    },
    []
  );

  return (
    <form onSubmit={handleSearchFormSubmit}>
      <div className="relative w-full text-gray-400 focus-within:text-gray-600">
        <div
          className="absolute inset-y-0 left-0 flex items-center pointer-events-none"
          aria-hidden="true"
        >
          <svg
            className="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <input
          id="search_field"
          className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 dark:text-white dark:bg-transparent placeholder-gray-500 focus:outline-none focus:ring-0 focus:border-transparent sm:text-sm"
          value={searchInput}
          onChange={(e) => {
            updateSearchInput(entity, e.target.value);
          }}
          placeholder={placeholder}
          type="search"
        />
      </div>
    </form>
  );
};

export default TableSearchInput;
